module.exports = __webpack_public_path__ + "static/media/Chapter 1 Slide 1-2.4814b695.jpg";